interface VendorInvoiceDetailsProps {
  rowData: any;
}

export const InvoiceView: React.FC<VendorInvoiceDetailsProps> = ({
  rowData,
}) => {
  return (
    <>
      <div className="">
        <div className="grid grid-cols-1 sm:grid-cols-2">
          {/* Left fields */}
          <div className="p-2 divide-y m-2">
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                <span className="text-red-500">*</span> Service No. Account:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.accountNumber}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                <span className="text-red-500">*</span>Corporate Office Number:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.storeNumber}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Office Status:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.officeStatus}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Office Name:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.officeName}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Office Address:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.officeStreet}, {rowData?.officeCity},{" "}
                {rowData?.officeStateCode}
              </div>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.officeZipcode}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Confie Brand:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.officeBrand}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                <div className="flex flex row">
                  <span className="text-red-500">*</span> Amount Paid:
                </div>
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.amountPaid}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                <div className="flex flex row">
                  <span className="text-red-500">*</span> Billing Period Start
                  Date:
                </div>
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.servicePeriodDate}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                <span className="text-red-500">*</span> Billing Period End Date:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.billingPeriodEndDate}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                <div className="flex flex row">
                  <span className="text-red-500">*</span>Invoice No.:
                </div>
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.invoiceNumber}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Date Capture:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.dateCapture}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Bank Reference:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.bankReference}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Bank Reference Date:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.bankReferenceDate}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Expense Account:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.expenseAccountDescription}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">Auto Pay:</label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.autoPayName}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Description:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.description}
              </div>
            </div>
          </div>
          {/* Right fields */}
          <div className="p-2 divide-y">
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Vendor Name:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.vendorName}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Vendor ID:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.vendorCode}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Bank Account:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.bankAccount
                  ? rowData?.bankAccount.replace(/.(?=.{4})/g, "x")
                  : null}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Utility Type:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.utilityType}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Branch GL:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.branchGL}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Subaccounts:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.glsubaccounts}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                <div className="flex flex row">
                  <span className="text-red-500">*</span> Due Date:
                </div>
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.duedate}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Previous Balance:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.previousBalance ? "Yes" : "No"}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                {rowData?.previousBalance ? (
                  <div className="flex flex row">
                    <span className="text-red-500">*</span>Previous Balance
                    Amount:
                  </div>
                ) : (
                  "Previous Balance Amount:"
                )}
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.previousBalanceAmount}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Draft Date:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.draftDate}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Invoice Image:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.invoiceImageAttachment}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">Note:</label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.noteSection}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Created By:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.createdBy}
              </div>
            </div>
            <div className="grid p-2 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Created Date:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {rowData?.createdDate
                  ? rowData?.createdDate &&
                    new Date(rowData?.createdDate).toLocaleDateString() +
                      " " +
                      new Date(rowData?.createdDate).toLocaleTimeString(
                        navigator.language,
                        {
                          hour: "2-digit",
                          minute: "2-digit",
                        }
                      )
                  : ""}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
